import { on } from 'delegated-events'

const slideToggleAll = document.querySelector('.slide-toggle-all')

const updateButton = (type) => {
  slideToggleAll.setAttribute('data-type', type)

  if (slideToggleAll.dataset.type === 'expand') {
    slideToggleAll.querySelector('span:first-child').textContent = 'Expand All'
  } else {
    slideToggleAll.querySelector('span:first-child').textContent = 'Collapse All'
  }
}

if (slideToggleAll) {
  on('click', '.slide-toggle-all', (e) => {
    const holder = e.currentTarget.closest('[data-slide-toggle-holder]')

    if (slideToggleAll.dataset.type === 'expand') {
      holder.querySelectorAll('[data-slide-toggle][aria-expanded="false"]').forEach((el) => el.click())
    } else {
      holder.querySelectorAll('[data-slide-toggle][aria-expanded="true"]').forEach((el) => el.click())
    }
  })

  on('slidetoggle:toggle', 'html', (e) => {
    const holder = e.detail.trigger.closest('[data-slide-toggle-holder]')
    const toggles = holder.querySelectorAll('[data-slide-toggle]')
    const expanded = holder.querySelectorAll('[data-slide-toggle][aria-expanded="true"]')

    if (expanded.length === toggles.length) {
      updateButton('collapse')
    } else {
      updateButton('expand')
    }
  })
}
